<template>
  <div class="d-timetal__container">
    <div class="d-guides">
      <StilGuides :video-id="'etaeiteazYM?start=112'"
                  textForLink="Guide: Se videoguide for ressourceforbrug"></StilGuides>
      <a class="text-link" target="_blank"
         href="https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2022/1012/Praktisk%20vejledning_Ressourceforbrug_2022.pdf">Læs
        officiel vejledning fra STIL</a>
      <p class="italic">Bemærk: I skal indberette, hvor mange undervisningsressourcer (målt i arbejdstimer), som skolen
        råder over, og hvordan skolen planlægger at bruge de undervisningsressourcer<br>
        Arbejdstiden for en fuldstidslærer er 1924 timer. Ud af dette findes et skøn for tid brugt på: Undervisning, UUV
        og Øvrig tid med eleverne (f.eks. elevsamtaler, gårdvagt og pause med eleverne)</p>
    </div>
    <table class="d-table">
      <thead class="center">
      <tr>
        <th style="min-width: 225px">
          <div class="filter-and-select">
            <span class="icon-filter"></span>
            <select v-model="activeUserFilter">
              <option v-for="stilStilling in stilStillingerWithCount" :value="stilStilling.value">
                {{ stilStilling.title }} ({{ stilStilling.count }})
              </option>
            </select>
          </div>
        </th>
        <th colspan="2" style="text-align: center">Arbejdstimer</th>
        <th colspan="2" style="text-align: center">Fagopdelt undervisning</th>
        <th colspan="2" style="text-align: center">Understøttende undervisning</th>
        <th colspan="2" style="text-align: center">Øvrig tid med eleverne<p class="text-explainer">(f.eks. elevsamtaler,
          gårdvagt og pauser med eleverne)</p></th>
      </tr>
      <tr class="thead-second-row">
        <th>
          <div class="select-all-and-button">
            <p class="select-all" @click="toggleAll">
              <span v-if="selectedUsers.length < 1">Vælg alle</span><span v-else>Fravælg alle</span>
            </p>
            <div v-if="selectedUsers.length < 1" class="hint--bottom-left" aria-label="Vælg brugere først">
              <button class="no-print bttn bttn--disabled">
                Indsæt på valgte
              </button>
            </div>
            <button v-else class="up__button" @click="isInsertOnMore = true">Indsæt på valgte</button>
          </div>
        </th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
        <th>Normalklasser</th>
        <th>Specialklasser</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, userIdx) in filteredUsersWithVProps" :key="user.id">
        <td class="td__select-user" @click="selectUser(user.id)"
            :class="{'td__select-user--selected': theActiveUserId === user.id}">
          <div class="name-and-title">
            <div class="name-and-title__checkbox">
              <div class="d-checkbox" :class="{'d-checkbox--active': getIsUserSelected(user.id)}"></div>
              <p>{{ user.name }}</p>
            </div>
            <div>
              <p class="d-pill" v-if="user.v_stil_stilling_title">
                {{ user.v_stil_stilling_title }}
              </p>
              <div class="hint--right"
                   :aria-label="theActiveUserId !== user.id ? 'Se opgaveoversigt' : 'Luk opgaveoversigt'">
                <div class="icon__bg-circle" @click.stop="setTheActiveUserId(user.id)">
                  <span class="icon-clipboard2" v-if="theActiveUserId !== user.id"></span>
                  <span v-else class="icon-cross2"></span>
                </div>
              </div>
            </div>
          </div>
          <StilRessourceTasks
            v-if="theActiveUserId === user.id"
            :userId="user.id"
            :schoolYear="activeSchoolYear"
            :startDate="activeSchoolYear.employee_time_start"
            :endDate="activeSchoolYear.employee_time_end">
          </StilRessourceTasks>
        </td>
        <td><input type="text" v-model="user.v_stil_hours_total_normal"
                   :class="{'number--empty': !user.v_stil_hours_total_normal}"
                   @blur="updateUser(user, 'stil_hours_40_B', $event.target.value)">
        </td>
        <td><input type="text" v-model="user.v_stil_hours_total_special"
                   :class="{'number--empty': !user.v_stil_hours_total_special}"
                   @blur="updateUser(user, 'stil_hours_50_B', $event.target.value)">
        </td>
        <td>
          <input type="text" v-model="user.v_stil_hours_fag_normal"
                 :class="{'number--empty': !user.v_stil_hours_fag_normal}"
                 @blur="updateUser(user, 'stil_hours_40_A1', $event.target.value)">
        </td>
        <td>
          <input type="text" v-model="user.v_stil_hours_fag_special"
                 :class="{'number--empty': !user.v_stil_hours_fag_special}"
                 @blur="updateUser(user, 'stil_hours_50_A1', $event.target.value)">
        </td>
        <td><input type="text" v-model="user.v_stil_hours_uuv_normal"
                   :class="{'number--empty': !user.v_stil_hours_uuv_normal}"
                   @blur="updateUser(user, 'stil_hours_40_A22', $event.target.value)">
        </td>
        <td><input type="text" v-model="user.v_stil_hours_uuv_special"
                   :class="{'number--empty': !user.v_stil_hours_uuv_special}"
                   @blur="updateUser(user, 'stil_hours_50_A22', $event.target.value)"></td>
        <td><input type="text" v-model="user.v_stil_hours_other_normal"
                   :class="{'number--empty': !user.v_stil_hours_other_normal}"
                   @blur="updateUser(user, 'stil_hours_40_A33', $event.target.value)"></td>
        <td><input type="text" v-model="user.v_stil_hours_other_special"
                   :class="{'number--empty': !user.v_stil_hours_other_special}"
                   @blur="updateUser(user, 'stil_hours_50_A33', $event.target.value)"></td>
      </tr>
      </tbody>
    </table>
    <GrundskoleIndberetningRessourceInsertModal
      v-if="isInsertOnMore"
      :selectedUsers="selectedUserObjects"
      :schoolId="schoolId"
      @updateRessource="updateRessourceFromModal"
      @close="closeInsertOnMore">
    </GrundskoleIndberetningRessourceInsertModal>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import GrundskoleIndberetningRessourceInsertModal from './GrundskoleIndberetningRessourceInsertModal'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import GrundskoleIndberetningRessourceOverview from './GrundskoleIndberetningRessourceOverview'
import DModal from '../common/DModal'
import UserTasks from '../User/UserTasks'
import StilRessourceTasks from './StilRessourceTasks'
import StilGuides from './StilGuides'

const klasseType = {
  stil_hours_40_B: {
    klassetype: '40',
    tidstype: 'B'
  },
  stil_hours_50_B: {
    klassetype: '50',
    tidstype: 'B'
  },
  stil_hours_40_A1: {
    klassetype: '40',
    tidstype: 'A1'
  },
  stil_hours_50_A1: {
    klassetype: '50',
    tidstype: 'A1'
  },
  stil_hours_40_A22: {
    klassetype: '40',
    tidstype: 'A22'
  },
  stil_hours_50_A22: {
    klassetype: '50',
    tidstype: 'A22'
  },
  stil_hours_40_A33: {
    klassetype: '40',
    tidstype: 'A33'
  },
  stil_hours_50_A33: {
    klassetype: '50',
    tidstype: 'A33'
  }
}

export default {
  components: {
    StilGuides,
    StilRessourceTasks,
    DModal, UserTasks, GrundskoleIndberetningRessourceOverview, GrundskoleIndberetningRessourceInsertModal
  },
  mixins: [clickaway],
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      activeUserFilter: '',
      isInsertOnMore: false,
      theActiveUserId: null,
      selectedUsers: []
    }
  },
  computed: {
    selectedUserObjects () {
      return this.selectedUsers.map(userId => {
        const idx = this.usersWithVProps.findIndex(user => user.id === userId)
        return this.usersWithVProps[idx]
      })
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolId () {
      return this.$route.params.school_id
    },
    stilStillinger () {
      return [
        {value: '', title: 'Alle'},
        {value: 'LA', title: 'Lærer'},
        {value: 'BH', title: 'Børnehaveklasseleder'},
        {value: 'PA', title: 'Pædagog'},
        {value: 'LE', title: 'Leder'},
        {value: 'AN', title: 'Andre med undervisningsopgaver', shortTitle: 'Andre med UV'},
        {value: 'undtaget', title: 'Ingen undervisningsopgaver', shortTitle: 'Ingen UV'}
      ]
    },
    stilStillingerWithCount () {
      return this.stilStillinger.map(stilling => {
        if (!stilling.value) {
          this.$set(stilling, 'count', this.usersWithVProps.length)
        } else {
          this.$set(stilling, 'count', this.usersWithVProps.filter(user => user.v_stil_stilling && user.v_stil_stilling === stilling.value).length)
        }
        return stilling
      })
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersWithVProps () {
      return this.users.map(user => {
        let birthday = null
        if (user.dob && user.dob.length > 6) {
          birthday = user.dob
        }
        this.$set(user, 'v_birthday', birthday)
        let stilStilling = null
        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][this.schoolId] && user.custom_data['schools'][this.schoolId]['stilling']) {
          stilStilling = user.custom_data['schools'][this.schoolId]['stilling']
        }
        this.$set(user, 'v_stil_stilling', stilStilling)
        this.$set(user, 'v_stil_stilling_title', this.getStilStillingTitle(stilStilling))
        this.$set(user, 'v_stil_hours_total_normal', this.getUserSetting(user, 'stil_hours_40_B'))
        this.$set(user, 'v_stil_hours_total_special', this.getUserSetting(user, 'stil_hours_50_B'))
        this.$set(user, 'v_stil_hours_fag_normal', this.getUserSetting(user, 'stil_hours_40_A1'))
        this.$set(user, 'v_stil_hours_fag_special', this.getUserSetting(user, 'stil_hours_50_A1'))
        this.$set(user, 'v_stil_hours_uuv_normal', this.getUserSetting(user, 'stil_hours_40_A22'))
        this.$set(user, 'v_stil_hours_uuv_special', this.getUserSetting(user, 'stil_hours_50_A22'))
        this.$set(user, 'v_stil_hours_other_normal', this.getUserSetting(user, 'stil_hours_40_A33'))
        this.$set(user, 'v_stil_hours_other_special', this.getUserSetting(user, 'stil_hours_50_A33'))
        return user
      })
    },
    unfilledUsers () {
      return this.usersWithVProps.filter(user => !user.gender || !user.v_birthday || !user.v_stil_stilling)
    },
    filteredUsersWithVProps () {
      if (!this.activeUserFilter || this.activeUserFilter.length < 1) {
        return this.usersWithVProps
      }
      return this.usersWithVProps.filter(user => user.v_stil_stilling && user.v_stil_stilling === this.activeUserFilter)
    }
  },
  methods: {
    updateRessourceFromModal (obj) {
      const changes = obj.change
      const user = obj.user
      let skemaer = this.stilData['ressourceskema']
      for (const updateProp in changes) {
        user['v_' + updateProp] = changes[updateProp]
        const idx = skemaer.findIndex(skema => skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'])
        skemaer[idx]['timer'] = this.getHoursPerPerson(user, user.v_stil_stilling, updateProp)
      }
      this.$emit('updateStil', skemaer)
    },
    updateRessource (user, updateProp) {
      let skemaer = this.stilData['ressourceskema']
      const idx = skemaer.findIndex(skema => skema._type === 'ressource' && skema.tidstype === klasseType[updateProp]['tidstype'] && skema.personaletype === user.v_stil_stilling && skema.klassetype === klasseType[updateProp]['klassetype'])
      skemaer[idx]['timer'] = this.getHoursPerPerson(user, user.v_stil_stilling, updateProp)
      this.$emit('updateStil', skemaer)
    },
    getHoursPerPerson (user, stilStilling, roleType) {
      const userSetting = 'v_' + roleType
      const users = this.users.filter(uUser => uUser.v_stil_stilling === stilStilling && uUser.id !== user.id)
      users.push(user)
      const arrOfAmounts = users.map(user => user[userSetting]).filter(val => val && ((val * 1) > 0))
      return arrOfAmounts.length > 0 ? arrOfAmounts.reduce((num, sum) => (sum * 1) + (num * 1)) : 0
    },
    closeInsertOnMore () {
      this.selectedUsers = []
      this.isInsertOnMore = false
    },
    toggleAll () {
      if (this.selectedUsers.length > 0) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = []
        this.filteredUsersWithVProps.forEach(user => this.selectedUsers.push(user.id))
      }
    },
    selectUser (userId) {
      const idx = this.selectedUsers.indexOf(userId)
      if (idx < 0) {
        this.selectedUsers.push(userId)
      } else {
        this.selectedUsers.splice(idx, 1)
      }
    },
    getIsUserSelected (userId) {
      return this.selectedUsers.indexOf(userId) > -1
    },
    setTheActiveUserId (userId) {
      if (this.theActiveUserId === userId) {
        this.theActiveUserId = null
      } else {
        this.theActiveUserId = userId
      }
    },
    getStilStillingTitle (val) {
      let title = ''
      if (!val || val.length === 0) {
        return title
      }
      const idx = this.stilStillinger.findIndex(stilling => stilling.value === val)
      if (idx > -1) {
        return this.stilStillinger[idx].shortTitle ? this.stilStillinger[idx].shortTitle : this.stilStillinger[idx].title
      } else {
        return title
      }
    },
    getUserSetting (user, setting) {
      let customData = user.custom_data
      if (customData['schools'] && customData['schools'][this.schoolId] && customData['schools'][this.schoolId][[setting]]) {
        return customData['schools'][this.schoolId][[setting]]
      } else {
        return ''
      }
    },
    updateUser (user, change, val) {
      const text = val.replace(',', '.')
      const numberInput = text * 1
      if (isNaN(numberInput)) {
        eventbus.toast = {text: 'Skal være et tal', success: false}
        return
      }
      let customData = user.custom_data
      let changes = {}
      if (!customData['schools']) {
        customData.schools = {[this.schoolId]: {[change]: numberInput}}
      }
      if (customData['schools'] && !customData['schools'][this.schoolId]) {
        customData['schools'][this.schoolId] = {[change]: numberInput}
      }
      if (customData['schools'] && customData['schools'][this.schoolId]) {
        if (val.length < 1) {
          delete customData['schools'][this.schoolId][[change]]
        } else {
          customData['schools'][this.schoolId][[change]] = numberInput
        }
      }
      changes['custom_data'] = customData
      docendo.updateUsers(this.schoolId, user.id, changes, data => {
        this.$store.commit('updateSchoolUser', data)
      }, failure => {
        console.log('failure')
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-timetal__container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

input[type="number"]:focus,
input[type="text"]:focus{
  border-color: var(--blue);
}

input[type="number"],
input[type="text"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 80px;
  max-width: 80px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
  opacity: 1;
  text-align: center;
  -webkit-appearance: none !important;
  margin: 0 auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"].number--empty:focus,
input[type="text"].number--empty:focus {
  opacity: 1;
}

.d-filters__filter.d-filters__filter--active > .d-pill {
  background: #e0e7ff;
  color: var(--primary);
  border-color: transparent;
}

.d-filters__filter > .d-pill {
  margin-left: 1rem;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #111827;
  padding: 4px 8px;
  font-weight: bold;
  background: transparent;
  border: 1px solid rgba(204, 204, 204, 0.75);
  font-size: 11px;
}

thead.center th {
  text-align: center;
  font-size: 10px;
  border: 1px solid #d8d8d8;
  line-height: 1.2;
}

thead tr.thead-second-row th {
  font-size: 10px;
}

.text-explainer {
  font-size: 8px;
  margin-top: 0.75rem;
  line-height: 1.2;
}

.d-pill {
  background: #eee;
  font-size: 10px;
  color: #222222;
  display: inline-block;
  border-radius: 4px;
  padding: 4px 8px;
  line-height: 10px;
}

.name-and-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.filter-and-select {
  display: flex;
  align-items: center;
}

.filter-and-select .icon-filter {
  margin-right: 0.5rem;
}


.d-filters {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
}

.d-filters__filter {
  padding: 0.5rem 1.5rem;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  margin-right: 1rem;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

.d-filters__filter.d-filters__filter--active {
  background: #f6f9fc;
  color: var(--primary)
}

.name-and-title__checkbox {
  display: flex;
  align-items: center;
}

.d-checkbox {
  margin-left: 0;
  margin-right: 1rem;
}

.select-all {
  text-align: left;
  color: var(--blue);
  text-transform: initial;
  cursor: pointer;
  user-select: none;
  transition: transform 0.25s;
}

.select-all:active {
  transform: scale(0.98);
}

.td__select-user {
  cursor: pointer;
  transition: transform 0.25s;
  position: relative;
}

.up__button {
  background-color: #468ad7 !important;
  color: #fff !important;
  border: 1px solid #4e80b7 !important;
}

.select-all-and-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.td__select-user.td__select-user--selected {
  padding: 0;
}

.td__select-user--selected .name-and-title {
  box-shadow: 0 3px 8px rgb(0 0 0 / 24%);
  padding: 0.5rem 1rem;
  border: 1px solid var(--blue);
  border-width: 1px 1px 0 1px;
  border-radius: 4px 4px 0 0;
  font-weight: bold;
}

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningRessource.vue?59918059